export const SUCCESSFULLYSENT = 1
export const PROCESSINGFAILED = 2
